module.exports = __webpack_public_path__ + "static/scale-model-of-friendship-park-in-jacksonville-florida-4ebf5c882868297d129bc742345c7577.png";